import React from "react";
import { Section } from "../Section";
import Application from "../../assets/images/application.png";
import Shipping from "../../assets/images/shipping.png";
import Assessment from "../../assets/images/assessment.png";
import Payment from "../../assets/images/payment.png";
import Triangle from "../../assets/images/triangle.svg";

import {
  ArrowImg,
  ImgWrap,
  PurchaseFlowItem,
  PurchaseFlowLabel,
  PurchaseFlowList,
  PurchaseFlowText,
  TestImg,
} from "./elements";

export const PurchaseFlow: React.FC = React.memo(() => {
  return (
    <Section title="買取の流れ">
      <PurchaseFlowList>
        <PurchaseFlowItem>
          <ImgWrap>
            <TestImg src={Application} />
          </ImgWrap>
          <PurchaseFlowLabel>WEB申し込み</PurchaseFlowLabel>
          <PurchaseFlowText>
            買取商品一覧から機種・スペックを選択し集荷依頼を申し込む
          </PurchaseFlowText>
        </PurchaseFlowItem>
        <ArrowImg src={Triangle} />
        <PurchaseFlowItem>
          <ImgWrap>
            <TestImg src={Shipping} />
          </ImgWrap>
          <PurchaseFlowLabel>商品の発送</PurchaseFlowLabel>
          <PurchaseFlowText>
            集荷時に梱包材を受け取りその場で梱包し発送
          </PurchaseFlowText>
        </PurchaseFlowItem>
        <ArrowImg src={Triangle} />
        <PurchaseFlowItem>
          <ImgWrap>
            <TestImg src={Assessment} />
          </ImgWrap>
          <PurchaseFlowLabel>査定結果</PurchaseFlowLabel>
          <PurchaseFlowText>
            弊社到着後に査定し、結果をメールでお知らせ
          </PurchaseFlowText>
        </PurchaseFlowItem>
        <ArrowImg src={Triangle} />
        <PurchaseFlowItem>
          <ImgWrap>
            <TestImg src={Payment} />
          </ImgWrap>
          <PurchaseFlowLabel>ご入金</PurchaseFlowLabel>
          <PurchaseFlowText>査定結果承諾後、銀行口座へご入金</PurchaseFlowText>
        </PurchaseFlowItem>
      </PurchaseFlowList>
    </Section>
  );
});

PurchaseFlow.displayName = "PurchaseFlow";
